import { createGaActionCreator } from '../../utils';
import {
    SELECT_PATIENT_GA_CATEGORY,
    GaActionText,
} from '../../pages/SelectPatient/constants';

const RESET = '@@selectpatient/RESET';
const CREATING_SUBPATIENT = '@@selectpatient/CREATING_SUBPATIENT';
const SUBPATIENT_CREATION_SUCCESS =
    '@@selectpatient/SUBPATIENT_CREATION_SUCCESS';
const SUBPATIENT_CREATION_FAILURE =
    '@@selectpatient/SUBPATIENT_CREATION_FAILURE';

const TRACK_FEMALE_GENDER_FIELD_SELECT =
    '@@selectpatient/TRACK_FEMALE_GENDER_FIELD_SELECT';
const TRACK_MALE_GENDER_FIELD_SELECT =
    '@@selectpatient/TRACK_MALE_GENDER_FIELD_SELECT';
const TRACK_IS_LEGAL_GUARDIAN_FIELD_SELECT =
    '@@selectpatient/TRACK_IS_LEGAL_GUARDIAN_FIELD_SELECT';
const TRACK_IS_NOT_LEGAL_GUARDIAN_FIELD_SELECT =
    '@@selectpatient/TRACK_IS_NOT_LEGAL_GUARDIAN_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_EMAIL_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_EMAIL_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_FIRST_NAME_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_FIRST_NAME_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_LAST_NAME_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_LAST_NAME_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_DAY_DOB_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_DAY_DOB_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_MONTH_DOB_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_MONTH_DOB_FIELD_SELECT';
const TRACK_NEW_SUB_PATIENT_YEAR_DOB_FIELD_SELECT =
    '@@selectpatient/TRACK_NEW_SUB_PATIENT_YEAR_DOB_FIELD_SELECT';

export const NewSubpatientFormActions = {
    RESET,
    CREATING_SUBPATIENT,
    SUBPATIENT_CREATION_SUCCESS,
    SUBPATIENT_CREATION_FAILURE,

    TRACK_FEMALE_GENDER_FIELD_SELECT,
    TRACK_MALE_GENDER_FIELD_SELECT,
    TRACK_IS_LEGAL_GUARDIAN_FIELD_SELECT,
    TRACK_IS_NOT_LEGAL_GUARDIAN_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_EMAIL_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_FIRST_NAME_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_LAST_NAME_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_DAY_DOB_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_MONTH_DOB_FIELD_SELECT,
    TRACK_NEW_SUB_PATIENT_YEAR_DOB_FIELD_SELECT,
};

export const reset = () => ({
    type: NewSubpatientFormActions.RESET,
});

export const creatingSubpatient = () => ({
    type: NewSubpatientFormActions.CREATING_SUBPATIENT,
});

export const subpatientCreationSuccess = (firstName, lastName, patientId) => ({
    type: NewSubpatientFormActions.SUBPATIENT_CREATION_SUCCESS,
    firstName,
    lastName,
    patientId,
});

export const subpatientCreationFailure = errorFields => ({
    type: NewSubpatientFormActions.SUBPATIENT_CREATION_FAILURE,
    errorFields,
});

const apiHost = process.env.API_HOST || '';
const createSubpatientEndpoint = mainPatientId =>
    `${apiHost}/api/web/2/patient/${mainPatientId}/subpatient`;

export function createSubpatient(mainPatientId, subpatient) {
    return dispatch => {
        dispatch(creatingSubpatient());
        subpatient.email =
            subpatient.email === undefined ? '' : subpatient.email;
        const isLegalGuardianBool = subpatient.isLegalGuardian === 'yes';

        const fetchData = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: subpatient.email,
                first_name: subpatient.firstName,
                last_name: subpatient.lastName,
                dob: subpatient.birthDate,
                gender: subpatient.sex,
                main_user_is_legal_guardian: isLegalGuardianBool,
            }),
            credentials: 'include',
        };
        let responseStatus;
        return fetch(createSubpatientEndpoint(mainPatientId), fetchData)
            .then(response => {
                responseStatus = response.status;
                if (responseStatus === 200) {
                    return response.json().then(body => {
                        if (body.error === null) {
                            dispatch(
                                subpatientCreationSuccess(
                                    subpatient.firstName,
                                    subpatient.lastName,
                                    body.data.patient_id
                                )
                            );
                        } else {
                            dispatch(
                                subpatientCreationFailure(body.error.fields)
                            );
                        }
                    });
                }

                return dispatch(subpatientCreationFailure());
            })
            .catch(() => {
                dispatch(subpatientCreationFailure());
            });
    };
}

/*
 Tracking Actions
 */

export const trackFemaleGenderFieldSelect = () =>
    createGaActionCreator(
        TRACK_FEMALE_GENDER_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackFemaleGenderFieldSelect
    );

export const trackMaleGenderFieldSelect = () =>
    createGaActionCreator(
        TRACK_MALE_GENDER_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackMaleGenderFieldSelect
    );

export const trackIsLegalGuardianFieldSelect = () =>
    createGaActionCreator(
        TRACK_IS_LEGAL_GUARDIAN_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackIsLegalGuardianFieldSelect
    );

export const trackIsNotLegalGuardianFieldSelect = () =>
    createGaActionCreator(
        TRACK_IS_NOT_LEGAL_GUARDIAN_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackIsNotLegalGuardianFieldSelect
    );

export const trackNewSubPatientEmailFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_EMAIL_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientEmailFieldSelect
    );

export const trackNewSubPatientFirstNameFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_FIRST_NAME_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientFirstNameFieldSelect
    );

export const trackNewSubPatientLastNameFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_LAST_NAME_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientLastNameFieldSelect
    );

export const trackNewSubPatientDayDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_DAY_DOB_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientDayDOBFieldSelect
    );

export const trackNewSubPatientMonthDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_MONTH_DOB_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientMonthDOBFieldSelect
    );

export const trackNewSubPatientYearDOBFieldSelect = () =>
    createGaActionCreator(
        TRACK_NEW_SUB_PATIENT_YEAR_DOB_FIELD_SELECT,
        SELECT_PATIENT_GA_CATEGORY,
        GaActionText.trackNewSubPatientYearDOBFieldSelect
    );

export const NewSubpatientFormTrackingActionCreators = {
    trackFemaleGenderFieldSelect,
    trackMaleGenderFieldSelect,
    trackIsLegalGuardianFieldSelect,
    trackIsNotLegalGuardianFieldSelect,
    trackNewSubPatientEmailFieldSelect,
    trackNewSubPatientFirstNameFieldSelect,
    trackNewSubPatientLastNameFieldSelect,
    trackNewSubPatientDayDOBFieldSelect,
    trackNewSubPatientMonthDOBFieldSelect,
    trackNewSubPatientYearDOBFieldSelect,
};
